"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createOrdersInfo;
function createOrdersInfo() {
    var fixture = init();

    function init() {
        return {
            availabilities: {}
        };
    }

    return {
        setAvailability: function setAvailability(_ref) {
            var availability = _ref.availability;

            fixture.availability = availability;
            return this;
        },
        setFutureDelayMins: function setFutureDelayMins(_ref2) {
            var min = _ref2.min,
                max = _ref2.max;

            fixture.future = fixture.future || {};
            fixture.future.delayMins = { min: min, max: max };
            return this;
        },
        disableFutureOrders: function disableFutureOrders() {
            fixture.future = fixture.future || {};
            fixture.future.disabled = true;
            return this;
        },
        enableFutureOrders: function enableFutureOrders() {
            fixture.future = fixture.future || {};
            delete fixture.future.disabled;
            return this;
        },
        disableAsapOrders: function disableAsapOrders() {
            fixture.asap = fixture.asap || {};
            fixture.asap.disabled = true;
            return this;
        },
        enableAsapOrders: function enableAsapOrders() {
            fixture.asap = fixture.asap || {};
            delete fixture.asap.disabled;
            return this;
        },
        setAsapPreOrderMins: function setAsapPreOrderMins(mins) {
            fixture.asap = fixture.asap || {};
            fixture.asap.preOrderMins = mins;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}